


































































































import { Component, Vue } from 'vue-property-decorator';
import { carouselData } from './data';
import arrowLeft from '@/assets/images/news/btn/left.png';
import arrowLeftDisabled from '@/assets/images/news/btn/disableLeft.png';
import arrowRight from '@/assets/images/news/btn/right.png';
import arrowRightDisabled from '@/assets/images/news/btn/disableRight.png';

@Component({
  name: 'Honor',
  components: {},
})
export default class extends Vue {
  activeIndex = 0;
  arrowLeft = arrowLeft;
  arrowLeftDisabled = arrowLeftDisabled;
  arrowRight = arrowRight;
  arrowRightDisabled = arrowRightDisabled;
  carouselData = carouselData;

  // 处于第一页 禁用向左轮播
  handlerPrev(e, fn) {
    if (this.activeIndex > 0) {
      fn(e);
    }
  }

  // 处于最后一页 禁用向右轮播
  handlerNext(e, fn) {
    if (this.activeIndex !== this.carouselData.length - 1) {
      fn(e);
    }
  }
}
